import React, { useState } from 'react';
import './ContactUs.css';

const ContactUs = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '', type: 'general' });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = 'Name is required';
    if (!form.email.trim() || !/\S+@\S+\.\S+/.test(form.email)) e.email = 'Valid email is required';
    if (!form.message.trim()) e.message = 'Message is required';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setForm({ name: '', email: '', phone: '', subject: '', message: '', type: 'general' });
    }, 1400);
  };

  const contactMethods = [
    {
      icon: '📍',
      title: 'Visit Our Studio',
      lines: ['Shop No: 108, Shiven Square, beside Swastik Party Plot, Adajan Gam, Surat, Gujarat 394510'],
      action: null,
    },
    {
      icon: '📧',
      title: 'Email Us',
      lines: ['fcreation08@gmail.com'],
      action: 'mailto:fcreation08@gmail.com',
      actionLabel: 'Send an Email',
    },
    {
      icon: '📱',
      title: 'WhatsApp',
      lines: ['+91 63555 92849', 'Mon – Sat, 10 AM – 7 PM'],
      action: 'https://wa.me/916355592849',
      actionLabel: 'Message on WhatsApp',
    },
    {
      icon: '🕐',
      title: 'Business Hours',
      lines: ['Monday – Saturday: 10 AM – 7 PM', 'Sunday: Closed'],
      action: null,
    },
  ];

  const enquiryTypes = [
    { value: 'general', label: 'General Enquiry' },
    { value: 'order', label: 'Order Support' },
    { value: 'corporate', label: 'Corporate Gifting' },
    { value: 'custom', label: 'Custom Design Request' },
    { value: 'bulk', label: 'Bulk Order (20+ units)' },
    { value: 'return', label: 'Return / Refund' },
  ];

  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="inner-hero">
        <div className="inner-hero__content container">
          <span className="about-eyebrow">We'd Love to Hear from You</span>
          <h1 className="inner-hero__title">Get in Touch</h1>
          <p className="inner-hero__sub">Whether you have a question, need a custom quote, or just want to say hello — we're always here.</p>
        </div>
      </section>

      <div className="container contact-body">

        {/* ── Contact methods ─────────────────────── */}
        <div className="contact-methods">
          {contactMethods.map((m) => (
            <div key={m.title} className="contact-method-card">
              <span className="contact-method-card__icon">{m.icon}</span>
              <h3 className="contact-method-card__title">{m.title}</h3>
              {m.lines.map((l, i) => <p key={i} className="contact-method-card__line">{l}</p>)}
              {m.action && (
                <a href={m.action} target="_blank" rel="noopener noreferrer" className="contact-method-card__link">
                  {m.actionLabel} →
                </a>
              )}
            </div>
          ))}
        </div>

        {/* ── Main grid ───────────────────────────── */}
        <div className="contact-grid">
          {/* Form */}
          <div className="contact-form-wrap">
            <h2 className="contact-form-title">Send Us a Message</h2>
            <p className="contact-form-sub">Fill in the form and we'll get back to you within 24 hours.</p>

            {submitted ? (
              <div className="contact-success">
                <div className="contact-success__icon">🎉</div>
                <h3>Message Received!</h3>
                <p>Thank you for reaching out, <strong>{form.name || 'there'}</strong>! We'll get back to you within 24 hours.</p>
                <button className="btn btn-primary-warm" style={{ marginTop: 20 }} onClick={() => setSubmitted(false)}>
                  Send Another Message
                </button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit} noValidate>
                {/* Enquiry type */}
                <div className="contact-form-group">
                  <label className="contact-label">Enquiry Type</label>
                  <div className="enquiry-types">
                    {enquiryTypes.map((t) => (
                      <label key={t.value} className={`enquiry-type ${form.type === t.value ? 'active' : ''}`}>
                        <input type="radio" name="type" value={t.value} checked={form.type === t.value} onChange={() => set('type', t.value)} />
                        {t.label}
                      </label>
                    ))}
                  </div>
                </div>

                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label className="contact-label">Full Name <span className="req">*</span></label>
                    <input
                      className={`contact-input ${errors.name ? 'error' : ''}`}
                      type="text"
                      placeholder="Rahul Sharma"
                      value={form.name}
                      onChange={(e) => set('name', e.target.value)}
                    />
                    {errors.name && <span className="contact-error">{errors.name}</span>}
                  </div>
                  <div className="contact-form-group">
                    <label className="contact-label">Email Address <span className="req">*</span></label>
                    <input
                      className={`contact-input ${errors.email ? 'error' : ''}`}
                      type="email"
                      placeholder="rahul@example.com"
                      value={form.email}
                      onChange={(e) => set('email', e.target.value)}
                    />
                    {errors.email && <span className="contact-error">{errors.email}</span>}
                  </div>
                </div>

                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label className="contact-label">Phone Number</label>
                    <input
                      className="contact-input"
                      type="tel"
                      placeholder="+91 98765 43210"
                      value={form.phone}
                      onChange={(e) => set('phone', e.target.value)}
                    />
                  </div>
                  <div className="contact-form-group">
                    <label className="contact-label">Subject</label>
                    <input
                      className="contact-input"
                      type="text"
                      placeholder="e.g. Bulk order enquiry"
                      value={form.subject}
                      onChange={(e) => set('subject', e.target.value)}
                    />
                  </div>
                </div>

                <div className="contact-form-group">
                  <label className="contact-label">Your Message <span className="req">*</span></label>
                  <textarea
                    className={`contact-input contact-textarea ${errors.message ? 'error' : ''}`}
                    rows={5}
                    placeholder="Tell us how we can help. For corporate or bulk orders, please mention the quantity and occasion."
                    value={form.message}
                    onChange={(e) => set('message', e.target.value)}
                  />
                  {errors.message && <span className="contact-error">{errors.message}</span>}
                  <span className="contact-hint">{form.message.length}/1000 characters</span>
                </div>

                <button type="submit" className={`btn btn-primary-warm btn-lg contact-submit ${loading ? 'loading' : ''}`} disabled={loading}>
                  {loading ? (
                    <><span className="contact-spinner" /> Sending…</>
                  ) : (
                    <>Send Message 🎁</>
                  )}
                </button>
              </form>
            )}
          </div>

          {/* Right sidebar */}
          <aside className="contact-sidebar">
            {/* Corporate CTA */}
            <div className="contact-sidebar-card contact-sidebar-card--dark">
              <span className="contact-sidebar-card__icon">💼</span>
              <h3>Corporate Gifting?</h3>
              <p>Get a custom quote for bulk orders of 20+ units with branding, packaging, and personalisation.</p>
              <ul className="corporate-perks">
                {['Volume discounts', 'Custom branding', 'Dedicated account manager', 'Flexible payment terms'].map((p) => (
                  <li key={p}>✓ {p}</li>
                ))}
              </ul>
              <a href="https://wa.me/916355592849" target="_blank" rel="noopener noreferrer" className="btn" style={{ background: '#25d366', color: 'white', width: '100%', marginTop: 16, textAlign: 'center' }}>
                💬 WhatsApp for Quote
              </a>
            </div>

            {/* Response time */}
            <div className="contact-sidebar-card">
              <h3>Our Response Times</h3>
              <div className="response-times">
                {[
                  { channel: '📧 Email', time: 'Within 24 hrs' },
                  { channel: '💬 WhatsApp', time: 'Within 2–3 hrs' },
                  { channel: '📞 Call Back', time: 'Same business day' },
                ].map((r) => (
                  <div key={r.channel} className="response-row">
                    <span>{r.channel}</span>
                    <strong>{r.time}</strong>
                  </div>
                ))}
              </div>
            </div>

            {/* Social */}
            <div className="contact-sidebar-card">
  <h3>Follow Us</h3>
  <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>
    Stay inspired with our latest creations and gifting ideas.
  </p>

  <div className="contact-socials">
    {[
      { 
        name: 'Instagram', 
        handle: '@f_creation09', 
        icon: '📸', 
        color: '#e1306c',
        url: 'https://www.instagram.com/f_creation09'
      },
      { 
        name: 'Facebook', 
        handle: 'F Creation', 
        icon: 'f', 
        color: '#1877f2',
        url: 'https://www.facebook.com/Fcreation09/'
      },
    ].map((s) => (
      <a 
        key={s.name} 
        href={s.url} 
        target="_blank" 
        rel="noopener noreferrer"
        className="contact-social-btn"
      >
        <span 
          className="contact-social-icon" 
          style={{ background: s.color }}
        >
          {s.icon}
        </span>

        <div>
          <p className="contact-social-name">{s.name}</p>
          <p className="contact-social-handle">{s.handle}</p>
        </div>
      </a>
    ))}
  </div>
</div>
          </aside>
        </div>

        {/* ── Map placeholder ──────────────────────── */}
        <div className="contact-map">
          <div className="contact-map__placeholder">
            <div className="contact-map__pin">📍</div>
            <h3>F Creation (The Gifting Studio)</h3>
            <p>Shop No: 108, Shiven Square, beside Swastik Party Plot, Adajan Gam, Surat, Gujarat 394510</p>
            <a
              href="https://maps.app.goo.gl/FPWwJwxKxnpLfpbA8"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline btn-sm"
              style={{ marginTop: 16 }}
            >
              Open in Google Maps →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
